angular
  .module('contributor')

  .factory('ContributorCertificationsCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class ContributorCertificationsCrud extends Crud {
        constructor(list) {
          super(
            'contributorCertifications' + (list || ''),
            '@@apiUrl' + '/contributor-certifications' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return ContributorCertificationsCrud;
    }
  ]);
